import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  StatusBar, SafeAreaView, StyleSheet, View, ScrollView, Text,
} from 'react-native';
import { Card } from 'react-native-paper';
import Header from '../components/Header';
import VideoModal from '../components/VideoModal';
import TextModal from '../components/TextModal';
import GradientButton from '../components/GradientButton';
import APMStyles from '../styles';

const modalType = {
  closed: 'closed',
  video: 'video',
  text: 'text',
};

function Exercises({ navigation }) {
  const exercises = useSelector((state) => state.training.exercises);

  const [modal, setModal] = useState(modalType.closed);
  const [video, setVideo] = useState('');
  const [text, setText] = useState('');

  function closeModal() {
    setModal(modalType.closed);
  }

  return (
    <View style={styles.container}>
      <SafeAreaView style={styles.header}>
        <StatusBar barStyle="dark-content" />
        <Header backButton style={styles.header} navigation={navigation} />
      </SafeAreaView>

      <View style={styles.content}>
        <ScrollView
          horizontal={false}
        >
          <VideoModal
            video={video}
            visible={modal === modalType.video}
            closeModal={closeModal}
          />
          <TextModal
            text={text}
            visible={modal === modalType.text}
            closeModal={closeModal}
          />
          {
            exercises && exercises.map((element) => (
              <Card key={element.exercise.name} style={styles.card}>
                <Card.Content>
                  <Text style={styles.title}>{element.exercise.name.toUpperCase()}</Text>
                  <Text style={styles.title}>{element.directions.toUpperCase()}</Text>
                </Card.Content>
                <Card.Cover source={{ uri: 'https://media4.giphy.com/media/7WLeao2bXtKXm/giphy.gif' }} />
                <Card.Actions>
                  <GradientButton
                    onPress={() => {
                      setVideo(element.exercise.video);
                      setModal(modalType.video);
                    }}
                  >
                    Video
                  </GradientButton>
                  <GradientButton
                    onPress={() => {
                      setText(element.exercise.text);
                      setModal(modalType.text);
                    }}
                    outline
                  >
                    Text
                  </GradientButton>
                </Card.Actions>
              </Card>
            ))
          }
        </ScrollView>
      </View>

      <View style={styles.buttonContainer}>
        <GradientButton>
          END WORKOUT
        </GradientButton>
      </View>

    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: APMStyles.colors.background,
  },
  header: {
    flex: 1,
  },
  content: {
    flex: 10,
    marginTop: 2,
  },
  buttonContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  button: {
    height: 50,
    width: 250,
    justifyContent: 'center',
  },
  title: {
    letterSpacing: 2,
    fontSize: APMStyles.typography.title,
    color: APMStyles.colors.text,
  },
  paragraph: {
    fontSize: APMStyles.typography.paragraph,
    color: APMStyles.colors.text,
  },
  card: {
    backgroundColor: APMStyles.colors.background,
  },
});

export default Exercises;
